import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-da799e52"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "confirm-dialog"
};
const _hoisted_2 = {
  class: "title font-16-medium"
};
const _hoisted_3 = {
  key: 0,
  class: "sub-title font-14-medium"
};
const _hoisted_4 = {
  class: "btn-group font-14-medium"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "confirm-container",
    onClick: _cache[2] || (_cache[2] = _withModifiers($event => $setup.emits('cancel'), ["stop"]))
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.title), 1), $props.subTitle ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($props.subTitle), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "btn cancel",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $setup.emits('cancel'), ["stop"]))
  }, _toDisplayString($props.cancelBtnText), 1), _createElementVNode("div", {
    class: "btn confirm",
    onClick: _cache[1] || (_cache[1] = _withModifiers($event => $setup.emits('confirm'), ["stop"]))
  }, _toDisplayString($props.confirmBtnText), 1)])])]);
}